<script setup lang="ts">
import { Video } from '~/types';

interface Props {
  video: Video;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="w-full pt-[57%] relative">
    <iframe
      v-if="video.wmt_video_uuid"
      :src="`https://video.wmt.media/embed/${props.video.wmt_video_uuid}`"
      class="absolute top-0 left-0 w-full h-full m-0"
      allowfullscreen
    />
  </div>
</template>
